module.exports = __webpack_public_path__ + "static/media/management-OA-01.c018fb52.jpg";